import {React} from 'common'
import {Page, PageContent} from 'components/Page'
import {styled} from '@mui/material'
import {Colors, Images, Texts} from 'appearance'
import useLoginScreen from 'logic/screens/useLoginScreen'
import {useDeviceDetect} from 'services/hooks'
import SmsVerificationSection from 'components/Auth/Login/SmsVerificationSection'
import LoginDetailsSection from 'components/Auth/Login/LoginDetailsSection'
import LoginTitle from 'components/Auth/Login/LoginTitle'

const Login = () => {
    const {isMobile} = useDeviceDetect()

    const {
        login,
        control,
        errors,
        errorMessage,
        isLoadingVerifySms,
        isLoadingLogin,
        loginErrorMessage,
        verifySmsErrorMessage,
        showSmsVerification,
        setShowSmsVerification,
        onVerifySms,
        handleSendSms,
        username,
        timeStr,
    } = useLoginScreen()

    return (
        <WhitePage noheader nodrawer>
            <PageContent centered>
                <ContentContainer>
                    <FormContainer isMobile={isMobile}>
                        {!isMobile && <ContentBlock />}
                        <LoginTitle
                            isMobile={isMobile}
                            showSmsVerification={showSmsVerification}
                            setShowSmsVerification={setShowSmsVerification}
                            username={username}
                        />
                        <ContentBlock>
                            {!!errorMessage && (
                                <ErrorMessage>{errorMessage}</ErrorMessage>
                            )}
                            {!showSmsVerification ? (
                                <LoginDetailsSection
                                    login={login}
                                    control={control}
                                    errors={errors}
                                    isLoadingVerifySms={isLoadingVerifySms}
                                    isLoadingLogin={isLoadingLogin}
                                    loginErrorMessage={loginErrorMessage}
                                />
                            ) : (
                                <SmsVerificationSection
                                    isLoadingVerifySms={isLoadingVerifySms}
                                    isLoadingLogin={isLoadingLogin}
                                    onVerifySms={onVerifySms}
                                    handleSendSms={handleSendSms}
                                    control={control}
                                    errors={errors}
                                    verifySmsErrorMessage={
                                        verifySmsErrorMessage
                                    }
                                    timeStr={timeStr}
                                    username={username}
                                />
                            )}
                        </ContentBlock>

                        {isMobile ? (
                            <ContentBlock />
                        ) : (
                            <Logo src={Images.POWERED_BY} />
                        )}
                    </FormContainer>
                    {!isMobile && <Image src={Images.WEBSITE_IMAGE} />}
                </ContentContainer>
            </PageContent>
        </WhitePage>
    )
}

export default Login

const WhitePage = styled(Page)`
    background-color: ${Colors.APP_WHITE};
`

const ContentBlock = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
`

const ContentContainer = styled('div')`
    background: #fff;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
`

const FormContainer = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-inline: ${({isMobile}) => (isMobile ? 20 : 100)}px;
    flex: 1;
    position: relative;
`

const Logo = styled('img')`
    height: 36px;
    width: 300px;
    align-self: center;
    padding-inline: 20px;
    margin-top: 28px;
    margin-bottom: 18px;
    bottom: 18px;
`
const Image = styled('img')`
    flex: 1.3;
`

const ErrorMessage = styled(Texts.RegularText)`
    color: red;
    font-size: 16px;
    text-align: center;
`
